import userStore from './user'

export default {
  namespaced: true,
  
  state: {
    defaultDashboard: null, // 'warehouse', 'sales', 'inventory', null
    availableDashboards: [],
    lastViewedDashboard: null,
    hiddenWidgets: [] // Array of widget IDs user chose to hide
  },
  
  mutations: {
    SET_DEFAULT_DASHBOARD(state, dashboard) {
      state.defaultDashboard = dashboard
      localStorage.setItem('defaultDashboard', dashboard)
    },
    
    SET_AVAILABLE_DASHBOARDS(state, dashboards) {
      state.availableDashboards = dashboards
    },
    
    SET_LAST_VIEWED_DASHBOARD(state, dashboard) {
      state.lastViewedDashboard = dashboard
      localStorage.setItem('lastViewedDashboard', dashboard)
    },
    
    LOAD_PREFERENCES(state) {
      state.defaultDashboard = localStorage.getItem('defaultDashboard')
      state.lastViewedDashboard = localStorage.getItem('lastViewedDashboard')
      const hidden = localStorage.getItem('hiddenWidgets')
      state.hiddenWidgets = hidden ? JSON.parse(hidden) : []
    },
    
    TOGGLE_WIDGET_VISIBILITY(state, widgetId) {
      const index = state.hiddenWidgets.indexOf(widgetId)
      if (index > -1) {
        state.hiddenWidgets.splice(index, 1)
      } else {
        state.hiddenWidgets.push(widgetId)
      }
      localStorage.setItem('hiddenWidgets', JSON.stringify(state.hiddenWidgets))
    }
  },
  
  actions: {
    setDefaultDashboard({ commit }, dashboard) {
      commit('SET_DEFAULT_DASHBOARD', dashboard)
    },
    
    setLastViewedDashboard({ commit }, dashboard) {
      commit('SET_LAST_VIEWED_DASHBOARD', dashboard)
    },
    
    loadPreferences({ commit }) {
      commit('LOAD_PREFERENCES')
    },
    
    toggleWidgetVisibility({ commit }, widgetId) {
      commit('TOGGLE_WIDGET_VISIBILITY', widgetId)
    },
    
    analyzeUserPermissions({ commit }) {
      const permissions = userStore.getters.permissions || []
      const availableDashboards = []
      
      // Check for warehouse dashboard permission
      const hasWarehouseDashboard = permissions.some(p => 
        p.permissionBase === 'Warehouse.API:WarehouseDashboard' && 
        p.permissionName === 'View'
      )
      if (hasWarehouseDashboard) {
        availableDashboards.push({
          id: 'warehouse',
          name: 'Warehouse Dashboard',
          icon: 'mdi-warehouse',
          route: '/warehouse/dashboard'
        })
      }
      
      // Check for other dashboards (add as needed)
      // Sales, Inventory, etc.
      
      commit('SET_AVAILABLE_DASHBOARDS', availableDashboards)
      
      return availableDashboards
    },
    
    determinePrimaryDashboard({ state }) {
      // Priority order:
      // 1. User's saved preference
      // 2. Last viewed dashboard
      // 3. Auto-detect based on permissions
      
      if (state.defaultDashboard) {
        return state.defaultDashboard
      }
      
      if (state.lastViewedDashboard) {
        return state.lastViewedDashboard
      }
      
      // Auto-detect logic
      const permissions = userStore.getters.permissions || []
      
      // Count permissions per module
      const warehousePermissions = permissions.filter(p => 
        p.permissionBase && p.permissionBase.includes('Warehouse.API')
      ).length
      
      const salesPermissions = permissions.filter(p => 
        p.permissionBase && p.permissionBase.includes('Sales')
      ).length
      
      const inventoryPermissions = permissions.filter(p => 
        p.permissionBase && p.permissionBase.includes('Inventory')
      ).length
      
      // If user has overwhelming warehouse permissions, default to warehouse
      if (warehousePermissions > salesPermissions && warehousePermissions > inventoryPermissions) {
        return 'warehouse'
      }
      
      // Check if user type is warehouse-focused
      const userType = userStore.getters.userType
      if (userType === 'warehouse' || userType === 'warehousemanager') {
        return 'warehouse'
      }
      
      // Default: show system overview
      return 'overview'
    }
  },
  
  getters: {
    defaultDashboard: state => state.defaultDashboard,
    availableDashboards: state => state.availableDashboards,
    lastViewedDashboard: state => state.lastViewedDashboard,
    hasMultipleDashboards: state => state.availableDashboards.length > 1,
    hiddenWidgets: state => state.hiddenWidgets,
    isWidgetHidden: (state) => (widgetId) => {
      return state.hiddenWidgets.includes(widgetId)
    }
  }
}
